import * as PopoverPrimitive from '@radix-ui/react-popover';

import { cn } from '../../lib/styles';

export type PopoverProps = React.ComponentProps<typeof PopoverPrimitive.Root>;

export type PopoverTriggerProps = React.ComponentProps<typeof PopoverPrimitive.Trigger>;

function Popover({ ...props }: PopoverProps) {
  return <PopoverPrimitive.Root data-slot="popover" {...props} />;
}

function PopoverTrigger({ ...props }: PopoverTriggerProps) {
  return <PopoverPrimitive.Trigger data-slot="popover-trigger" {...props} />;
}

function PopoverClose({ ...props }: React.ComponentProps<typeof PopoverPrimitive.Close>) {
  return <PopoverPrimitive.Close data-slot="popover-close" {...props} />;
}

export type PopoverContentProps = React.ComponentProps<typeof PopoverPrimitive.Content> & {
  naked?: boolean;
  withinPortal?: boolean;
};

function PopoverContent({
  className,
  align = 'center',
  sideOffset = 4,
  naked = false,
  withinPortal = false,
  ...rest
}: PopoverContentProps) {
  const content = (
    <PopoverPrimitive.Content
      data-slot="popover-content"
      align={align}
      sideOffset={sideOffset}
      updatePositionStrategy="always"
      className={cn(
        'data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50 w-72 origin-(--radix-popover-content-transform-origin)',
        {
          'bg-white text-text-primary rounded-2xl border p-4 shadow-md outline-hidden': !naked,
          'dark:bg-black/80 dark:text-white dark:border-black/80': !naked,
        },
        className,
      )}
      {...rest}
    />
  );

  if (!withinPortal) return content;

  return <PopoverPrimitive.Portal>{content}</PopoverPrimitive.Portal>;
}

function PopoverAnchor({ ...props }: React.ComponentProps<typeof PopoverPrimitive.Anchor>) {
  return <PopoverPrimitive.Anchor data-slot="popover-anchor" {...props} />;
}

export { Popover, PopoverTrigger, PopoverContent, PopoverAnchor, PopoverClose };
